import React from "react";
import PropTypes from "prop-types";

import BaseChart from "./BaseChart";

// had to change this up a bit from the DeviceAnalytics version to support drilldown.
// Might be able to use their version, but would need a lot more work.

export class DonutChart extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    series: PropTypes.array.isRequired,
    colors: PropTypes.arrayOf(PropTypes.string),
    decimals: PropTypes.number,
    verticalLegend: PropTypes.bool
  };

  render() {
    let { series, drilldown, height, colors, decimals, verticalLegend } = this.props;

    return (
      <BaseChart
        decimals={decimals}
        colors={colors}
        options={{
          chart: {
            type: "pie",
            height: height
          },
          title: {
            text: null
          },
          legend: {
            squareSymbol: true,
            symbolRadius: 3,
            ...(verticalLegend
              ? {
                  align: "left",
                  layout: "vertical",
                  floating: true
                }
              : {})
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: false
              },
              showInLegend: true
            }
          },
          series: series.map(s => ({
            innerSize: "40%",
            ...s
          })),
          drilldown: { series: drilldown }
        }}
      />
    );
  }
}

export default DonutChart;
